import React from 'react';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Carlos Rodríguez',
      role: 'Director de Operaciones',
      company: 'AutoMéxico SA',
      content: 'VIN Pro Platform ha transformado nuestra operación. La velocidad y precisión de las consultas nos ha permitido mejorar significativamente nuestro servicio al cliente.',
      rating: 5
    },
    {
      name: 'María Vásquez',
      role: 'Gerente de Auditoría',
      company: 'Grupo Automotriz del Norte',
      content: 'La trazabilidad completa y los reportes detallados son exactamente lo que necesitábamos. El sistema de auditoría es impecable y cumple con todas nuestras necesidades regulatorias.',
      rating: 5
    },
    {
      name: 'Jorge Martínez',
      role: 'Coordinador de Sistemas',
      company: 'Distribuidora Automotriz Central',
      content: 'La gestión de usuarios y los controles de seguridad nos dan total tranquilidad. La implementación fue rápida y el soporte técnico es excepcional.',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Testimonios de Clientes
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Empresas líderes en la industria automotriz confían en VIN Pro Platform
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials?.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-card border border-border rounded-lg p-6 shadow-elevation hover:shadow-elevation-md transition-all duration-300"
            >
              {/* Rating */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, idx) => (
                  <Icon key={idx} name="Star" size={16} className="text-warning fill-warning" />
                ))}
              </div>

              {/* Content */}
              <p className="text-sm text-muted-foreground mb-6 italic">
                "{testimonial?.content}"
              </p>

              {/* Author */}
              <div className="flex items-center space-x-3 pt-4 border-t border-border">
                <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-full">
                  <Icon name="User" size={20} className="text-primary" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground">
                    {testimonial?.name}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {testimonial?.role}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {testimonial?.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Success Metrics */}
        <div className="mt-12 md:mt-16 bg-card border border-border rounded-lg p-8 shadow-elevation">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl md:text-4xl font-bold text-primary mb-2">98%</div>
              <div className="text-sm text-muted-foreground">Satisfacción del Cliente</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-primary mb-2">45%</div>
              <div className="text-sm text-muted-foreground">Reducción en Tiempo de Consulta</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-primary mb-2">24/7</div>
              <div className="text-sm text-muted-foreground">Soporte Técnico Disponible</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;